<template>
    <tr class="dashboard__list_learner_table_item_collapse_table_item">
        <td class="dashboard__list_learner_table_item_collapse_table_item_date">{{ occurrenceItemDate }}</td>
        <td class="dashboard__list_learner_table_item_collapse_table_item_time">{{ occurrenceItemTime }}</td>
        <td class="dashboard__list_learner_table_item_collapse_table_item_trainers">
            <ul>
                <li
                    :class="trainer.isActive === false ? 'dashboard__list_learner_table_item_collapse_table_item_trainers--error' : ''"
                    :key="index"
                    v-for="(trainer, index) in occurrenceItemTrainers"
                >{{ trainer.name }}{{ trainer.isActive === false ? ` (Inactive)` : '' }}
                </li>
            </ul>
        </td>
        <td class="dashboard__list_learner_table_item_collapse_table_item_location">{{ occurrenceItemLocation }}</td>
        <td class="dashboard__list_learner_table_item_collapse_table_item_actions">
            <div class="columns is-variable">
                <div class="column"></div>
                <template v-if="occurrenceItemLocation && occurrenceType === 'face_to_face'">
                    <div class="column is-narrow">
                        <component-button
                            :name="'dashboard-list-learner-table-item-collapse-map'"
                            :theme="'default'"
                            :icon="true"
                            :icon-name="'map-pin'"
                            :icon-align="'right'"
                            @click="openNotifyMap"
                        >{{ $t('dashboard.buttons.showMap') }}</component-button>
                    </div>
                </template>
                <template v-else-if="occurrenceItemLocation && occurrenceType === 'virtual' && name !== 'lms-superadmin-users-profile-edit-learning-history-events'">
                    <component-button
                        :name="'dashboard-list-learner-table-item-accessdetails'"
                        :theme="'default'"
                        :to="{ name: 'ebs-session-show', params: { eventId: eventId, sessionId: occurrenceId } }"
                    >Access details</component-button>
                </template>
            </div>
            <pop-notify
                v-if="occurrenceItemLocation && occurrenceType === 'face_to_face'"
                ref="notifymap"
                :title-text="occurrenceItemLocation"
                :content-text="occurrenceItemAddressFormatted"
                :submit-button-active="false"
                :cancel-button-text="$t('dashboard.buttons.close')"
            >
                <component-map :address="occurrenceItemAddress"/>
            </pop-notify>
        </td>
    </tr>
</template>

<script>

import { sortByKey, toLocaleTime, toLocaleDateTime, fromUTCDateTimeToLocalISOCustom } from '@/functions'
import ComponentButton from '@/components/default/shared/ComponentButton'
import PopNotify from '@/components/default/shared/PopNotify'
import ComponentMap from '@/components/default/shared/ComponentMap'

export default {
  name: 'dashboard-list-learner-table-item-collapse-table-item',
  components: { ComponentMap, PopNotify, ComponentButton },
  computed: {
    eventId () {
      return this.event.eventId
    },
    occurrenceItemDate () {
      const dateStart = toLocaleDateTime(fromUTCDateTimeToLocalISOCustom(this.item.datetimeStart || this.item.startDate))
      const dateEnd = toLocaleDateTime(fromUTCDateTimeToLocalISOCustom(this.item.datetimeEnd || this.item.endDate))
      return dateStart !== dateEnd ? `${dateStart} - ${dateEnd}` : dateStart
    },
    occurrenceItemTime () {
      const timeStart = toLocaleTime(fromUTCDateTimeToLocalISOCustom(this.item.datetimeStart || this.item.startDate))
      const timeEnd = toLocaleTime(fromUTCDateTimeToLocalISOCustom(this.item.datetimeEnd || this.item.endDate))
      return timeStart + ' - ' + timeEnd
    },
    occurrenceItemTrainers () {
      return sortByKey(this.item.trainers, 'name')
    },
    occurrenceType () {
      return this.item.sessionType
    },
    occurrenceId () {
      return this.event.occurrenceId
    },
    occurrenceItemLocation () {
      const occurrenceType = this.occurrenceType
      const location = this.item.location
      const venue = this.item.venue ? this.item.venue.name : null
      const room = this.item.room ? this.item.room.name : null
      const platform = this.item.platform
      let output

      switch (occurrenceType) {
        case 'virtual':
          output = platform
          break
        default:
          output = location || (venue && room ? `${venue} - ${room}` : '')
          break
      }

      return output
    },
    occurrenceItemAddress () {
      return this.item.location || this.item.venue.address
    },
    occurrenceItemAddressFormatted () {
      return this.item.location ? this.item.location : (this.item.venue.address.formatted_address + (this.item.room.location ? `(${this.item.room.location})` : ''))
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    event: {
      type: Object
    },
    name: {
      type: String
    }
  },
  methods: {
    openNotifyMap () {
      this.$refs.notifymap.openNotify()
    }
  }
}
</script>
